import React from 'react';
import { IconButton } from '@material-ui/core';
import { useHistory } from 'react-router';
import DeleteIcon from '@material-ui/icons/Delete';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import { useDispatch } from 'react-redux';
import VatReturnDetailsActions from 'redux/reducers/vatReturn_detail_reducer/actions';
import * as VatReturnUtils from '../../../../utils';
import { SupplyTypes } from 'config';

interface IProps {
  rowIndex: number;
  mode: 'VIEW' | 'EDIT';
}

interface ISuppliesFromMemberStateOfIdentification {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
}

export default function ActionsBlock(props: IProps) {
  // const history = useHistory();
  const MODE = props.mode;
  const dispatch = useDispatch();

  const handleClick = (rowIndex: number) => {
    let newData: Array<ISuppliesFromMemberStateOfIdentification> = new Array<ISuppliesFromMemberStateOfIdentification>();
    let reduxData = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER)
      .vatReturnDetail.suppliesFromMemberStateOfIdentification.items;
    let item = null;
    for (let index in reduxData)
      if (Number.parseInt(index) !== rowIndex) newData.push(reduxData[index]);
      else item = reduxData[index];
    dispatch(
      VatReturnDetailsActions.setSuppliesFromMemberStateOfIdentificationAction({
        items: newData,
        total_vat_amount_payable_goods: VatReturnUtils.calculateTotalVatAmount(
          newData,
          SupplyTypes.GOODS
        ),
        total_vat_amount_payable_services: VatReturnUtils.calculateTotalVatAmount(
          newData,
          SupplyTypes.SERVICES
        ),
      })
    );
    msconChanges(item);
  };

  const msconChanges = (object: ISuppliesFromMemberStateOfIdentification) => {
    let reduxData = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER)
      .vatReturnDetail.mscon;
    let newMsconData = [];
    for (let item of reduxData) {
      if (item.country_id !== object.consumer_id) newMsconData.push(item);
      else {
        let total_msid_goods = item.total_msid_goods;
        let total_msid_services = item.total_msid_services;
        if (object.supply_type === 'GOODS')
          total_msid_goods -= object.taxable_amount;
        else total_msid_services -= object.taxable_amount;
        let due_balance = item.due_balance - object.vat_amount;
        let obj = {
          ...item,
          total_msid_goods,
          total_msid_services,
          grand_total:
            total_msid_goods +
            total_msid_services +
            item.total_msest_goods +
            item.total_msest_services,
          due_balance: due_balance,
          total_amount_due: due_balance + item.total_correction,
        };
        if (obj.total_correction > 0 || obj.total_amount_due > 0)
          newMsconData.push(obj);
      }
    }
    dispatch(VatReturnDetailsActions.setMsconAction(newMsconData));
  };

  return (
    <div>
      <IconButton
        disabled={MODE === 'VIEW'}
        color="primary"
        onClick={() => handleClick(props.rowIndex)}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );
}
